import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "content-details first"
}
const _hoisted_2 = { class: "value" }
const _hoisted_3 = {
  key: 0,
  class: "content-details"
}
const _hoisted_4 = { class: "value" }
const _hoisted_5 = {
  key: 0,
  class: "content-details"
}
const _hoisted_6 = { class: "value" }
const _hoisted_7 = {
  key: 0,
  class: "content-details"
}
const _hoisted_8 = {
  key: 0,
  class: "content-details"
}
const _hoisted_9 = { class: "value" }
const _hoisted_10 = {
  key: 0,
  class: "content-details"
}
const _hoisted_11 = { class: "value" }
const _hoisted_12 = {
  key: 0,
  class: "content-details"
}
const _hoisted_13 = { class: "value" }
const _hoisted_14 = {
  key: 0,
  class: "content-details status"
}
const _hoisted_15 = { class: "content-icons" }
const _hoisted_16 = { class: "icons" }
const _hoisted_17 = ["src"]
const _hoisted_18 = ["src"]
const _hoisted_19 = ["src"]
const _hoisted_20 = {
  key: 0,
  class: "content-details action"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("tr", {
    key: $props.savedPackage._id
  }, [
    _createElementVNode("td", {
      class: _normalizeClass({ 'details-package-open': $props.isDetailsPackageOpen === $props.savedPackage._id })
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["first-row-package bold", { 'padding-left': $props.isDetailsPackageOpen === $props.savedPackage._id }])
      }, _toDisplayString($props.getEstateTitle($props.savedPackage.estateId)), 3),
      ($props.isDetailsPackageOpen === $props.savedPackage._id)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "title" }, "Land Size", -1)),
            _createElementVNode("div", _hoisted_2, _toDisplayString($props.getLandSize($props.savedPackage.selections.lot.lotId) || "-") + "sqm", 1)
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("td", {
      class: _normalizeClass({ 'details-package-open': $props.isDetailsPackageOpen === $props.savedPackage._id })
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["first-row-package", { padding: $props.isDetailsPackageOpen === $props.savedPackage._id }])
      }, _toDisplayString($props.savedPackage.selections.lot.name || "-"), 3),
      ($props.isDetailsPackageOpen === $props.savedPackage._id)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "title" }, "Build Size", -1)),
            _createElementVNode("div", _hoisted_4, _toDisplayString($props.getBuildSize($props.savedPackage.selections.house.houseId) || "-") + "sqm", 1)
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("td", {
      class: _normalizeClass({ 'details-package-open': $props.isDetailsPackageOpen === $props.savedPackage._id })
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["first-row-package", { padding: $props.isDetailsPackageOpen === $props.savedPackage._id }])
      }, _toDisplayString($props.savedPackage.selections.builder.name || "-"), 3),
      ($props.isDetailsPackageOpen === $props.savedPackage._id)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "title" }, "Facade", -1)),
            _createElementVNode("div", _hoisted_6, _toDisplayString($props.savedPackage.selections.facade.name || "-"), 1)
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("td", {
      class: _normalizeClass({ 'details-package-open': $props.isDetailsPackageOpen === $props.savedPackage._id })
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["first-row-package", { padding: $props.isDetailsPackageOpen === $props.savedPackage._id }])
      }, _toDisplayString($props.savedPackage.selections.house.name || "-"), 3),
      ($props.isDetailsPackageOpen === $props.savedPackage._id)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[7] || (_cache[7] = [
            _createElementVNode("div", { class: "title no-visibility" }, "House", -1),
            _createElementVNode("div", { class: "value no-visibility" }, "Design", -1)
          ]))]))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("td", {
      class: _normalizeClass({ 'details-package-open': $props.isDetailsPackageOpen === $props.savedPackage._id })
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["first-row-package", { padding: $props.isDetailsPackageOpen === $props.savedPackage._id }])
      }, _toDisplayString($props.formatPrice($props.savedPackage.selections.lot.price) || "-"), 3),
      ($props.isDetailsPackageOpen === $props.savedPackage._id)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "title" }, "Beds", -1)),
            _createElementVNode("div", _hoisted_9, _toDisplayString($props.getBedroomCount($props.savedPackage.selections.house.houseId) || "-"), 1)
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("td", {
      class: _normalizeClass({ 'details-package-open': $props.isDetailsPackageOpen === $props.savedPackage._id })
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["first-row-package", { padding: $props.isDetailsPackageOpen === $props.savedPackage._id }])
      }, _toDisplayString($setup.calculateBuildPriceOrPackagePriceTotal($props.savedPackage.selections.house.price, $props.savedPackage.selections.facade.price, $setup.siteCosts) || "-"), 3),
      ($props.isDetailsPackageOpen === $props.savedPackage._id)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "title" }, "Baths", -1)),
            _createElementVNode("div", _hoisted_11, _toDisplayString($props.getBathroomCount($props.savedPackage.selections.house.houseId) || "-"), 1)
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("td", {
      class: _normalizeClass({ 'details-package-open': $props.isDetailsPackageOpen === $props.savedPackage._id })
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["first-row-package", { padding: $props.isDetailsPackageOpen === $props.savedPackage._id }])
      }, _toDisplayString($setup.calculateBuildPriceOrPackagePriceTotal($props.savedPackage.selections.house.price, $props.savedPackage.selections.facade.price, $setup.siteCosts, $props.savedPackage.selections.lot.price) || "-"), 3),
      ($props.isDetailsPackageOpen === $props.savedPackage._id)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "title" }, "Living", -1)),
            _createElementVNode("div", _hoisted_13, _toDisplayString($props.getLoungeRoomCount($props.savedPackage.selections.house.houseId) || "-"), 1)
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("td", {
      class: _normalizeClass({ 'details-package-open': $props.isDetailsPackageOpen === $props.savedPackage._id })
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["first-row-package", { 'padding-top': $props.isDetailsPackageOpen === $props.savedPackage._id }])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["badge", $props.getLotClass($props.savedPackage.selections.lot.lotId)])
        }, _toDisplayString($props.getLotStatus($props.savedPackage.selections.lot.lotId) || "-"), 3)
      ], 2),
      ($props.isDetailsPackageOpen === $props.savedPackage._id)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [...(_cache[11] || (_cache[11] = [
            _createElementVNode("div", { class: "title no-visibility" }, "Lot", -1),
            _createElementVNode("div", { class: "value no-visibility" }, "Status", -1)
          ]))]))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("td", {
      class: _normalizeClass({ 'details-package-open': $props.isDetailsPackageOpen === $props.savedPackage._id })
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["first-row-package", { 'padding-top': $props.isDetailsPackageOpen === $props.savedPackage._id }])
      }, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", {
              class: "trash-button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.onDeletePackage($props.savedPackage._id)))
            }, [
              _createElementVNode("img", {
                class: "trash-icon",
                src: require(`@/assets/icons/trash.svg`)
              }, null, 8, _hoisted_17)
            ]),
            _createElementVNode("div", {
              class: "edit-button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($props.onClickPackage($props.savedPackage._id)))
            }, [
              _createElementVNode("img", {
                class: "edit-icon",
                src: require(`@/assets/icons/edit.svg`)
              }, null, 8, _hoisted_18)
            ]),
            _createElementVNode("div", {
              class: "link-button",
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.onCopyLinkPackage($props.savedPackage)))
            }, [
              _createElementVNode("img", {
                class: "link-icon",
                src: require(`@/assets/icons/icon-link-green.svg`)
              }, null, 8, _hoisted_19)
            ])
          ]),
          _createElementVNode("button", {
            class: _normalizeClass(["dropdown-button details-package", { active: $props.isDisplayDetailsEffect && $props.isDetailsPackageOpen === $props.savedPackage._id }]),
            onClick: _cache[3] || (_cache[3] = ($event: any) => ($props.openDetailsPackage($props.savedPackage._id)))
          }, null, 2)
        ])
      ], 2),
      ($props.isDetailsPackageOpen === $props.savedPackage._id)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [...(_cache[12] || (_cache[12] = [
            _createElementVNode("div", { class: "title no-visibility" }, "Lot", -1),
            _createElementVNode("div", { class: "value no-visibility" }, "Status", -1)
          ]))]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}